import { HashRouter, Routes, Route } from 'react-router-dom';
import DailyTruthPage from './pages/DailyTruthPage';
import LoginPage from './pages/LoginPage';
import CreatePostPage from './pages/CreatePostPage';
import CreateShowcasePage from './pages/CreateShowcasePage';
import SignupPage from './pages/SignupPage';
import BoardPage from './pages/BoardPage';
import CollectionsPage from './pages/CollectionsPage';
import PhotoObservationPage from './pages/PhotoObservationPage';
import VideoDiscussionPage from './pages/VideoDiscussionPage';
import ClaimLensPage from './pages/ClaimLensPage';
import MirrorRoomPage from './pages/MirrorRoomPage';
import AdminPage from './pages/admin/AdminPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import PublicShell from './components/public/PublicShell';
import { AlertProvider } from './components/common/useCustomAlert';
import { getAllPosts, votePost } from './api/postApi';
import './AppTheme.css';
import './styles/public-redesign.css';
import RouteAnalyticsTracker from './analytics/RouteAnalyticsTracker';

function App() {
    return (
        <AlertProvider>
            <HashRouter>
                <RouteAnalyticsTracker />
                <Routes>
                    <Route
                        path="/"
                        element={
                            <PublicShell>
                                <DailyTruthPage
                                    loadPostsRequest={getAllPosts}
                                    voteRequest={votePost}
                                />
                            </PublicShell>
                        }
                    />
                    <Route path="/login" element={<PublicShell><LoginPage /></PublicShell>} />
                    <Route path="/create" element={<PublicShell><CreatePostPage /></PublicShell>} />
                    <Route path="/create-photo" element={<PublicShell><CreateShowcasePage /></PublicShell>} />
                    <Route path="/signup" element={<PublicShell><SignupPage /></PublicShell>} />
                    <Route path="/board" element={<PublicShell><BoardPage /></PublicShell>} />
                    <Route path="/collections" element={<PublicShell><CollectionsPage /></PublicShell>} />
                    <Route path="/observation" element={<PublicShell><PhotoObservationPage /></PublicShell>} />
                    <Route path="/watch" element={<PublicShell><VideoDiscussionPage /></PublicShell>} />
                    <Route path="/lens" element={<PublicShell><ClaimLensPage /></PublicShell>} />
                    <Route path="/mirror" element={<PublicShell><MirrorRoomPage /></PublicShell>} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/privacy" element={<PublicShell><PrivacyPolicy /></PublicShell>} />
                </Routes>
            </HashRouter>
        </AlertProvider>
    );
}

export default App;
